<div :class="$style.upload">
  <submission-foundry-dropdown
    v-if="['in_work', 'in_correction', 'cancelled'].includes(submission.status)"
    :id="$vId(this)"
  ></submission-foundry-dropdown>
  <uploader-label
    :id="$vId(this)"
    :status="submission.status"
    v-if="['in_work', 'live', 'cancelled'].includes(submission.status)"
  />
  <uploader :id="$vId(this)" v-if="['in_work', 'cancelled'].includes(submission.status)" />
  <live-uploader-disable 
    :id="$vId(this)" 
    v-if="submission.status ==='live' && !isFontsPSComplete" />
  <live-uploader 
    :id="$vId(this)" 
    v-if="submission.status ==='live' && isFontsPSComplete" />
  <div :class="$style.aditional_info">
    {{$t('pages.submissions.index.additional_detail_binaryuploader')}}
  </div>
  <live-results 
    :id="$vId(this)" 
    v-if="submission.status === 'live' " />
  <results :id="$vId(this)" v-if="submission.status !== 'live'" />
  <designers :id="$vId(this)" v-if="binariesList.length > 0 || submissionBinaries.length > 0" />
  <defaultStyle :id="$vId(this)" v-if="binariesList.length > 0 || submissionBinaries.length > 0" />

  <TextField
    name="binary amount upload"
    label="binary amount"
    type="hidden"
    :id="$vId(this, 'binary amount upload')"
    v-model="submissionBinaries.length"
    :show-error-message="true"
    rules="binary_amount"
  />
</div>
